import { Observable } from 'rxjs';
import { TaxesRepository } from '../domain/taxes/repository';
import HttpClient from '../utils/http-client';
import { ApiResponse } from '../domain/common/api-response';

export class TaxesRepositoryImplementation extends TaxesRepository {
    get(page: number, limit: number): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.get(`/taxes?page=${page}&limit=${limit}`);
    }

    create(body: any): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.post('/taxes', body);
    }

    getById(id: number): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.get(`/taxes/${id}`);
    }

    update(id: number, body: any): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.put(`/taxes/${id}`, body);
    }

    delete(id: number): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.delete(`/taxes/${id}`);
    }
}
